import { useQuery } from '@tanstack/react-query';
import { dtpApi } from '../lib/dtpApi';
import { useDtpParams } from '../lib/clinicSite';
import { useDtpAuthStore } from '../store/useDtpAuthStore';

export const patientUnreadMessagesKey = (physicianId?: string, patientId?: string) =>
  ['patient-care-unread', physicianId, patientId] as const;

/**
 * Messages from the care team the patient hasn't opened yet, for the nav badge.
 * Polls once a minute; the Messages page refreshes it when the patient reads.
 * Zero while signed out or when the count can't be loaded — a badge is a hint,
 * never an error.
 */
export function usePatientUnreadMessages(): number {
  const { physicianId } = useDtpParams();
  const patientId = useDtpAuthStore(s => s.patient?._id);
  const isAuthenticated = useDtpAuthStore(s => s.isAuthenticated);
  const query = useQuery({
    queryKey: patientUnreadMessagesKey(physicianId, patientId),
    enabled: Boolean(isAuthenticated && patientId),
    refetchInterval: 60_000,
    retry: false,
    queryFn: async () => {
      const res = await dtpApi.getCareUnreadCount();
      return res.success && res.data ? res.data.count : 0;
    },
  });
  return query.data ?? 0;
}
